import { Col, Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants/shared';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $QuoteItemSummaryRow = styled(Row)`
  margin-bottom: ${spacing('md')};
  color: ${({ theme }) => theme.colors.paragraphTextColor};
  padding: 0;

  @media ${media.minWidth.md} {
    padding: 0 ${spacing('xxl')};
  }
`;

export const $QuoteItemSummariesStyled = styled.div`
  margin-top: ${spacing(2.5)};
`;

export const $QuoteItemSummariesTitle = styled.div`
  font-weight: ${fontWeight('bold')};
  margin-bottom: ${spacing(2.5)};
  margin-top: ${spacing('lg')};
`;

export const $QuoteItemSummariesCommments = styled.div`
  padding: 0;
  color: ${({ theme }) => theme.colors.paragraphTextColor};

  @media ${media.minWidth.md} {
    padding: 0 ${spacing('xxl')};
  }
`;

export const $InlinePriceCol = styled(Col)`
  flex: none;
`;
